<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Manage Roles</h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <n-button
                                @click.native="openModal()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>

                        </div>
                        
                        <fg-input>
                            <el-input type="search"  class="mb-3" style="width: 400px"
                            prefix-icon="el-icon-search"
                            :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                            v-model="searchQuery"
                            aria-controls="datatables"
                            ></el-input>
                        </fg-input>
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        <el-table-column
                            min-width="250"
                            prop="permissions"
                            label="Permissions"
                            align="left"
                            header-align="left"
                        >
                            <template slot-scope="scope">
                                <template v-for="(permission, index) in scope.row.permissions">
                                    <span class="badge badge-default m-1" v-if="permission" :class="`${permission.split('.')[1]}`"  :key="index">{{ permission }}</span>
                                </template> 
                            </template>
                        </el-table-column>
                        <el-table-column :min-width="135" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <n-button
                                    @click.native="handleView(props.$index, props.row)"
                                    class="view"
                                    type="primary"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-eye"></i>
                                </n-button>
                                <n-button
                                    @click.native="handleEdit(props.$index, props.row)"
                                    class="edit"
                                    type="warning"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-pencil"></i>
                                </n-button>
                                <n-button
                                    @click.native="handleDelete(props.$index, props.row)"
                                    class="remove"
                                    type="danger"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-times"></i>
                                </n-button>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

        <modal :show.sync="modals.add" headerClasses="justify-content-center" footerClasses="justify-content-center" type="large">
            <h4 slot="header" class="title title-up">Add New Role</h4>
            <form>
                <div class="row">
                    <div class="col-12">
                        <fg-input
                            type="text"
                            required
                            name="title"
                            label="Role Title"
                            v-validate="modelValidations.title"
                            :error="getError('title')"
                            v-model="model.title">
                        </fg-input>
                    </div>
                    <div class="col-12">
                        <el-transfer
                            filterable
                            :filter-method="filterMethod"
                            filter-placeholder="Permissions"
                            v-model="model.permissions"
                            :titles="['Available', 'Selected']"
                            :data="transfer_data">
                        </el-transfer> 
                    </div>
                </div>
            </form>
            <template slot="footer">
                <n-button @click.native.prevent="validate()" type="primary">Save Role</n-button>
            </template>
        </modal>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Transfer } from "element-ui";
import { Pagination as NPagination, Modal } from "src/components";
import users from "../../../Dashboard/Tables/users";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Transfer.name]: Transfer,
        Modal
    },
    computed: {
        ...mapGetters({
            tableData: 'getRoles',
            permissions: 'getPermissions',
            preferences: 'getPreferences'
        }),

        transfer_data(){
            const data = [];
            if(this.permissions)
                this.permissions.forEach((permission, index) => {
                    data.push({
                        label: permission,
                        key: index
                    });
                });
            return data;
        },
        
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "title", "slug" ],
            tableColumns: [
                {
                    prop: "slug",
                    label: "Slug",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "title",
                    label: "Title",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return `${cellValue.charAt(0).toUpperCase() + cellValue.slice(1)}`; 
                    }
                }
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false
            },
            model: {
                title: '',
                permissions: []
            },
            modelValidations: {
                title: {
                    required: true,
                },
            },
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    },
    methods: {
        handleView(index, row) {
            swal({
                title: `You liked ${row.title}`,
                buttonsStyling: false,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill"
            });
        },
        handleEdit(index, row) {
            this.model.title = row.title
            this.model.slug = row.slug
            this.model.permissions = []
            row.permissions.forEach((permission, index) => {
                this.model.permissions.push(this.permissions.findIndex(perm => perm == permission))
            });
            this.scope = 'edit'
            this.modals.add = true
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        deleteRow(row) {
            // let indexToDelete = this.tableData.findIndex(
            //     tableRow => tableRow.id === row.id
            // );
            // if (indexToDelete >= 0) {
            //     this.tableData.splice(indexToDelete, 1);
            // }
            this.$store.dispatch('deleteRole', row.slug)
        },
        openModal(){

            this.errors.clear();
            this.$nextTick(() => {
                this.$validator.reset();
            });
            
            this.model.title = ''
            
            this.model.permissions = []
            this.scope = 'add'
            this.modals.add = true
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            this.$validator.validateAll().then(isValid => {
                // this.$emit('on-submit', this.registerForm, isValid);
                if(isValid){
                    let permissions = []
                    this.model.permissions.forEach((permission, index) => {
                        permissions.push(this.permissions[permission])
                    })
                    this.model.permissions = permissions
                    
                    switch(this.scope){
                        case 'add'  : this.$store.dispatch('createRole', this.model); break;
                        case 'edit' : this.$store.dispatch('updateRole', this.model); break;
                    }
                    
                    this.modals.add = false
                }
            });
        }
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getPermissions');
        this.$store.dispatch('getRoles');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .cell{
        span.badge{
            // font-weight: normal;

            &.create{
                color: #27ae60!important;
                border-color: #27ae60!important;
                background-color: #fff!important;
            }

            &.read{
                color: #2980b9!important;
                border-color: #2980b9!important;
                background-color: #fff!important;
            }

            &.update{
                color: #f39c12!important;
                border-color: #f39c12!important;
                background-color: #fff!important;
            }

            &.delete{
                color: #c0392b!important;
                border-color: #c0392b!important;
                background-color: #fff!important;
            }
        }
    }

    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }
    
</style>

